import type { CatalogueScopeState } from '@/lib/catalog/catalogue-scope';

const documentListSpans = [
  { before: "Какие документы к металлоизделиям и конструкциям вы получаете:", after: "Состав документов согласуют для конкретного заказа. В зависимости от изделия и работ он может включать:" },
  { before: "УПД (универсальный передаточный документ), который теперь заменяет ТТН и счёт фактуру", after: "УПД или другие применимые передаточные документы" },
  { before: "Сертификат на материалы, которые использовались при изготовлении", after: "Документы о качестве материалов, предусмотренные для конкретного изделия и поставки" },
] as const;

const reviewedNeutralIntro = 'Документы конкретного заказа и изделия необходимо согласовать перед поставкой. Возможный перечень:';

/** Qualify only the exact reviewed shared list for currently approved catalogue pages. */
export function getReviewedDocumentListHtml(html: string, state: CatalogueScopeState = 'unknown'): string {
  if (state !== 'approved_non_support') return html;
  const introCount = [documentListSpans[0].before, reviewedNeutralIntro]
    .reduce((count, intro) => count + html.split(intro).length - 1, 0);
  if (introCount !== 1) return html;
  if (!documentListSpans.slice(1).every(({ before }) => html.split(before).length - 1 === 1)) return html;
  return documentListSpans.reduce((value, { before, after }) => value.replace(before, after), html);
}
